const splitVectorToArray = (splitVector) => {
  if (typeof splitVector === 'string') {
    if (splitVector.indexOf(',') > 0) {
      return splitVector.split(',').map((entry) => Number(entry));
    }

    return [Number(splitVector)];
  }

  return splitVector.map((entry) => Number(entry));
};

const ListingMap = ({
  id,
  status,
  eventId,
  eventDescription,
  eventCountry,
  eventDate,
  createdDate,
  listingSource,
  inhandDate,
  quantity,
  quantityRemain,
  section,
  rows,
  venueConfigSectionId,
  splitOption,
  splitQuantity,
  deliveryOption,
  preDelivered,
  saleMethod,
  pricePerProduct,
  buyerSeesPerProduct,
  ticketTraits,
  products,
  hideSeats,
  eventTimezone,
  ticketMedium,
  splitVector,
  stubhubMobileTicket,
  deliveryMethods,
  scrubbedSectionName,
  localizedSectionName,
  isScrubbingEnabled,
  isParkingPassOnlyEvent,
  sectionMappingRequired,
  proSellerInfo,
}) => {
  return {
    id: Number(id),
    status,
    eventId: Number(eventId),
    eventDescription,
    eventCountry,
    eventDate,
    createdDate,
    listingSource,
    inhandDate,
    quantity: Number(quantity),
    quantityRemain: Number(quantityRemain),
    section,
    rows,
    venueConfigSectionId: Number(venueConfigSectionId),
    splitOption,
    splitQuantity: Number(splitQuantity),
    deliveryOption,
    preDelivered,
    saleMethod,
    pricePerProduct,
    buyerSeesPerProduct,
    ticketTraits,
    products,
    hideSeats,
    eventTimezone,
    ticketMedium,
    splitVector: splitVectorToArray(splitVector),
    stubhubMobileTicket,
    deliveryMethods,
    scrubbedSectionName,
    localizedSectionName,
    isScrubbingEnabled,
    isParkingPassOnlyEvent,
    sectionMappingRequired,
    proSellerInfo,
  };
};

export default ListingMap;
